export const VARCHAR_255 = 255;
export const VARCHAR_100 = 100;
export const VARCHAR_50 = 50;
export const VARCHAR_2 = 2;



// WEBPACK FOOTER //
// ./src/main/resources/js/utils/numberConstants.js